<template>
  <div v-loading="loading" class="ec-line015">
    <div class="subscription-info-form">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: $routePage.EC_LINE009 }"> {{ $t('ec-line009.heading') }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: $routePage.EC_LINE014 }">{{ $t('ec-line014.title') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('ec-line015.heading') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form
        ref="form"
        :model="form"
        label-position="top"
        :rules="rules"
        :disabled="disableForm && disableFormByDateAndStatus"
      >
        <div class="lg:mb-8 mb-5">
          <the-heading class="my-0">
            {{ $t('ec-line015.heading') }}
          </the-heading>
          <div
            v-if="disableForm && disableFormByDateAndStatus"
            class="font-medium text-red text-base text-left mt-2 lg:mt-3"
          >
            {{ $t('ec-line015.cantCancelAndPause') }}
          </div>
        </div>

        <the-section :title="$t('ec-line015.content.purchaseDetails')" class="scroll--purchaseDetails">
          <div v-if="visibleProducts">
            <cart-list-item
              v-for="(item, idx) in subscriptionItems"
              :key="idx"
              :data="item"
              :index="idx"
              :disabled-item="disableForm && disableFormByDateAndStatus"
              :disable-delete-btn="disableDeleteProducts"
              @update-quantity="updateQuantity"
              @remove="removeItem"
            ></cart-list-item>
          </div>
          <hr class="mb-5 lg:mb-6 border-t border-solid border-gray-950 border-opacity-20" />
          <el-button class="cart-subscription-item__button font-normal py-2" @click="toListProduct">
            {{ $t('common.action.addProduct') }}
          </el-button>
          <cart-total
            v-if="!isEmpty(form) && visibleProducts && summaryStatus"
            :sub-total="subTotal"
            :sub-discount="subDiscount"
            :delivery-fee="deliveryFee"
            :tax="tax"
            :total="totalAmount"
          />
          <div v-else-if="lumpSumValidFlag" class="text-red text-base lg:text-lg mt-5 lg:mt-6">
            <p>{{ $t('ec-line015.message.lumpSumMessage1') }}</p>
            <p>{{ $t('ec-line015.message.lumpSumMessage2') }}</p>
            <p>{{ $t('ec-line015.message.lumpSumMessage3') }}</p>
          </div>
          <div v-else-if="!summaryStatus" class="text-red text-base lg:text-lg mt-5 lg:mt-6">
            <p>{{ $t('ec-line015.message.otherErrorMessage') }}</p>
          </div>
        </the-section>

        <the-section
          :ref="Constants.LIST_SECTION.SUBSCRIPTION_SECTION"
          :title="$t('ec-line015.content.subscription')"
          class="scroll-subscription"
        >
          <template slot="sub">
            <p class="lg:mx-6 mt-2">{{ $t('ec-line015.content.subscriptionNote') }}</p>
          </template>
          <el-form
            ref="subscriptionPatternForm"
            :model="subscriptionPatternForm"
            label-position="top"
            :rules="rules"
            :disabled="disableForm && disableFormByDateAndStatus"
          >
            <el-form-item class="mt-5">
              <el-radio
                class="radio-dot"
                :label="Constants.DELIVERY_PATTERN_CHANGE.MONTHLY_DATE_SPECIFICATION"
                v-model="subscriptionPatternForm.subscription_division_id"
                @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                >{{ $t('ec-line015.content.monthlyDateSpecification') }}</el-radio
              >

              <el-row :gutter="8" class="mt-3 lg:text-lg" type="flex">
                <el-col :span="6" :lg="5">
                  <el-select
                    v-model="subscriptionPatternForm.param1_1"
                    :placeholder="$t('common.pleaseSelect')"
                    :disabled="hasLumpSumPayment"
                    @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                  >
                    <el-option
                      v-for="item in monthly"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" :lg="7">{{ $t('ec-line015.content.everyMonth') }}</el-col>
                <el-col :span="6" :lg="5">
                  <el-select
                    v-model="subscriptionPatternForm.param1_2"
                    :placeholder="$t('common.pleaseSelect')"
                    @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                  >
                    <el-option
                      v-for="item in dayInMonth"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" :lg="7">{{ $t('ec-line015.content.deliverToTheDay') }}</el-col>
              </el-row>
              <p class="mt-1 lg:text-lg">{{ $t('ec-line015.content.monthlyNote') }}</p>
            </el-form-item>

            <el-form-item>
              <el-radio
                :label="Constants.DELIVERY_PATTERN_CHANGE.INTERVAL_DESIGNATION"
                v-model="subscriptionPatternForm.subscription_division_id"
                @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                >{{ $t('ec-line015.content.intervalDesignation') }}</el-radio
              >

              <el-row :gutter="12" class="mt-3 lg:text-lg" type="flex">
                <el-col :span="8">
                  <el-select
                    v-model="subscriptionPatternForm.param2_1"
                    :placeholder="$t('common.pleaseSelect')"
                    :disabled="hasLumpSumPayment"
                    @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                  >
                    <el-option
                      v-for="item in monthly"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="16">
                  {{ $t('ec-line015.content.everyMonth') }}
                </el-col>
              </el-row>

              <el-row :gutter="12" class="mt-3 lg:text-lg" type="flex">
                <el-col :span="8">
                  <el-select
                    v-model="subscriptionPatternForm.param2_2"
                    :placeholder="$t('common.pleaseSelect')"
                    @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                  >
                    <el-option
                      v-for="item in weekNo"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="subscriptionPatternForm.param2_3"
                    :placeholder="$t('common.pleaseSelect')"
                    @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                  >
                    <el-option
                      v-for="item in dayOfWeek"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  {{ $t('ec-line015.content.deliverTo') }}
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item :class="[hasLumpSumPayment ? 'opacity-30' : '']">
              <el-radio
                :label="Constants.DELIVERY_PATTERN_CHANGE.SPECIFY_DELIVERY_DATE_INTERVAL"
                v-model="subscriptionPatternForm.subscription_division_id"
                :disabled="hasLumpSumPayment"
                @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                >{{ $t('ec-line015.content.specifyDeliveryDateInterval') }}</el-radio
              >

              <el-row :gutter="12" class="mt-3 lg:text-lg" type="flex">
                <el-col :span="7">
                  <el-select
                    v-model="subscriptionPatternForm.param3_1"
                    :placeholder="$t('common.pleaseSelect')"
                    :disabled="hasLumpSumPayment"
                    @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.PATTERN)"
                  >
                    <el-option
                      v-for="item in dayDaily"
                      :key="item.value"
                      :value="item.label"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="17">
                  {{ $t('ec-line015.content.deliverDaily') }}
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item
              prop="next_delivery_date"
              :label="$t('ec-line015.content.nextDeliveryDate')"
              :rules="rules.next_delivery_date"
              :class="[unableChangeNextDelivery ? 'mb-2 next-delivery-form' : '']"
              class="row-layout-input mb-2"
            >
              <base-date-picker
                type="date"
                v-model="subscriptionPatternForm.next_delivery_date"
                :editable="false"
                :clearable="false"
                :disabled="subscriptionPatternForm.autoCalcLastDeliveryDate || disableNextDeliveryForm"
                :picker-options="pickerOptions1"
                :prefix-icon="subscriptionPatternForm.autoCalcLastDeliveryDate || disableNextDeliveryForm ? 'true' : ''"
                :format="Constants.FORMAT_DATE_JP"
                :value-format="Constants.FORMAT_DATE_HYPHEN"
                @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.NEXT_DELIVERY_DATE)"
              ></base-date-picker>
            </el-form-item>
            <el-form-item :show-message="false" class="mb-8">
              <div class="text-right">
                <base-checkbox
                  v-model="subscriptionPatternForm.autoCalcLastDeliveryDate"
                  :disabled="disableNextDeliveryForm"
                  @change="
                    updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.NEXT_DELIVERY_AUTO_CALCULATION)
                  "
                  >{{ $t('ec-line015.content.autoCalcLastDeliveryDate') }}</base-checkbox
                >
              </div>
            </el-form-item>

            <el-form-item
              prop="next_next_delivery_date"
              :label="$t('ec-line015.content.nextDeliveryDate2')"
              :rules="rules.next_next_delivery_date"
              class="row-layout-input mb-2"
            >
              <base-date-picker
                type="date"
                v-model="subscriptionPatternForm.next_next_delivery_date"
                :editable="false"
                :clearable="false"
                :disabled="subscriptionPatternForm.autoCalcLastDeliveryDate2"
                :picker-options="pickerOptions2"
                :prefix-icon="subscriptionPatternForm.autoCalcLastDeliveryDate2 ? 'true' : ''"
                :format="Constants.FORMAT_DATE_JP"
                :value-format="Constants.FORMAT_DATE_HYPHEN"
                @change="updateDeliveryPatternForm(Constants.DELIVERY_PATTERN_ACTION_TYPE.NEXT_NEXT_DELIVERY_DATE)"
              />
            </el-form-item>
            <el-form-item :show-message="false" class="mb-8">
              <div class="text-right">
                <base-checkbox
                  v-model="subscriptionPatternForm.autoCalcLastDeliveryDate2"
                  :disabled="false"
                  @change="
                    updateDeliveryPatternForm(
                      Constants.DELIVERY_PATTERN_ACTION_TYPE.NEXT_NEXT_DELIVERY_AUTO_CALCULATION
                    )
                  "
                  >{{ $t('ec-line015.content.autoCalcLastDeliveryDate2') }}</base-checkbox
                >
              </div>
            </el-form-item>
          </el-form>
          <section
            v-if="(hasPauseFlag || hasCancelFlag) && !isPausing"
            :ref="Constants.LIST_SECTION.PAUSE_SECTION"
            class="subscription-info-form__cancel-subscriptions"
          >
            <h2 class="text-body-01">{{ titlePauseOrCancelSection }}</h2>
            <hr class="subscription-info-form__cancel-subscriptions__ruler" />
            <p>{{ descriptionPauseOrCancelSection }}</p>
            <div v-if="hasPauseFlag && hasCancelFlag" class="flex flex-wrap lg:flex-nowrap justify-center mt-6">
              <el-button class="submit-btn lg:ml-6 lg:order-1" @click="handlePause">
                {{ $t('ec-line015.content.pauseSection.pauseBtn') }}
              </el-button>
              <el-button class="cancel-btn mt-6 lg:mt-0" @click="showCancelSubscriptionDialog">{{
                $t('ec-line015.content.cancelSection.cancelBtn')
              }}</el-button>
            </div>
            <div v-else class="mt-6 w-full text-center">
              <el-button v-if="hasPauseFlag" class="submit-btn" @click="handlePause">
                {{ $t('ec-line015.content.pauseSection.pauseBtn') }}
              </el-button>
              <el-button v-else class="submit-btn" @click="showCancelSubscriptionDialog">
                {{ $t('ec-line015.content.cancelSection.cancelBtn') }}
              </el-button>
            </div>
          </section>
        </the-section>

        <the-section :title="$t('ec-line015.content.shippingInformation')">
          <el-form label="top" :disabled="disableForm && disableFormByDateAndStatus">
            <el-form-item :label="$t('common.label.shippingAddressCard')" class="row-layout-input">
              <address-info-item
                v-if="customer_address"
                :full-name="fullName"
                :postal-code="customer_address.postal_code"
                :address="Utils.helper.address(prefecture_text, customer_address.addr01, customer_address.addr02)"
                :building-name="customer_address.addr03"
              >
                <template v-if="!hasCorporateFlag || addresses.length > 1" #action>
                  <el-button
                    type="text"
                    class="address-info-item__action__button-edit"
                    :disabled="disableForm && disableFormByDateAndStatus"
                    @click="showAddressDialog"
                  >
                    <span>{{ $t('common.action.changeShippingAddress') }}</span>
                  </el-button>
                </template>
              </address-info-item>
            </el-form-item>
            <el-form-item :label="$t('common.label.shippingMethod')" class="row-layout-input">
              <disabled-input :value="deliveryMethodText" />
            </el-form-item>
            <template>
              <el-form-item
                v-if="deliveryMethodText !== Constants.MAIL_DELIVERY_SERVICE"
                :label="$t('common.label.deliveryTimezone')"
                prop="time_id"
                class="row-layout-input"
              >
                <el-select
                  v-model="subscriptionPatternForm.time_id"
                  :placeholder="$t('common.pleaseSelect')"
                  :disabled="!isAvailableTimezone"
                >
                  <el-option
                    v-if="
                      subscriptionPatternForm.time_id !== null &&
                      subscriptionPatternForm.time_id !== undefined &&
                      !isTimeIdValid
                    "
                    :label="placeholderLabel"
                    :value="subscriptionPatternForm.time_id"
                  ></el-option>
                  <el-option
                    :value="null"
                    :label="
                      isAvailableTimezone
                        ? $t('common.placeholder.unspecified')
                        : $t('common.placeholder.unavailableTimeZone')
                    "
                  ></el-option>
                  <el-option
                    v-for="item in filteredDeliveryTime"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="
                  deliveryMethodText !== Constants.MAIL_DELIVERY_SERVICE && !hasCorporateFlag && !businessAccountFlag()
                "
                :label="$t('common.label.specifyDeliveryNote')"
                class="row-layout-input"
              >
                <el-select class="mb-1" v-model="form.delivery_note_id" clearable @change="changeDeliveryNotes">
                  <el-option
                    v-for="(item, index) in deliveryNotes"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                    >{{ item.label }}</el-option
                  >
                  <el-option class="hidden" :label="form.delivery_notes" :value="deliveryFreeTextId"></el-option>
                </el-select>
                <span class="whitespace-pre-line text-xs leading-normal block">{{ $t('common.shippingHint') }}</span>
              </el-form-item>
              <el-form-item
                v-if="visible_bundled_flag"
                :label="$t('common.label.bundledFlag')"
                class="row-layout-input"
              >
                <div class="flex flex-col">
                  <el-radio-group class="mb-1" v-model="form.bundled_flag" :disabled="isBundledFlagDisabled">
                    <el-radio class="radio-dot" :label="Constants.BUNDLED_FLAG.CANBE">
                      {{ $t('common.action.canBe') }}
                    </el-radio>
                    <el-radio class="radio-dot" :label="Constants.BUNDLED_FLAG.NONE">
                      {{ $t('common.action.none') }}
                    </el-radio>
                  </el-radio-group>
                  <span class="text-xs leading-normal">{{ $t('common.bundledHint') }}</span>
                  <span v-if="isNotBundledRemoteIsland" class="text-xs leading-normal mt-1 text-red">
                    {{ $t('common.isNotBundledRemoteIsland') }}
                  </span>
                  <span v-if="hasNomuSilicaLightProduct" class="text-xs leading-normal mt-1 text-red">
                    {{ $t('common.isNotBundledNomuSilicaLight') }}
                  </span>
                </div>
              </el-form-item>
            </template>
          </el-form>
        </the-section>

        <the-section :ref="Constants.LIST_SECTION.PAYMENT_SECTION" :title="$t('ec-line015.content.paymentInformation')">
          <template #subTitle>
            <el-button v-show="isAmazon && isLoginAmazon" id="changeCustomerPayment" class="section__button">{{
              $t('common.action.edit')
            }}</el-button>
            <el-button class="section__button" v-if="isCreditCard && cards.length" @click="showCardDialog">{{
              $t('common.action.edit')
            }}</el-button>
          </template>
          <template #sub>
            <p v-if="batchErrorType" class="text-red-150 text-base font-normal lg:mx-6 mt-2 whitespace-pre-wrap">
              {{ batchErrorType }}
            </p>
          </template>

          <el-form
            ref="paymentForm"
            :model="paymentForm"
            label-position="top"
            :rules="rules"
            :disabled="disableForm && disableFormByDateAndStatus"
          >
            <el-form-item :label="$t('common.memberInformation.paymentMethod')" prop="payment_id" required>
              <el-select
                v-if="!isLoginAmazon"
                v-model="paymentForm.payment_id"
                @change="onChangePaymentMethod(Constants.PAYMENT_DIALOG_TYPE.CHANGE_PAYMENT)"
              >
                <el-option
                  v-for="item in shopPaymentMethods"
                  v-show="item.visible && item.payment_service_id !== Constants.PAYMENT_METHOD.CASH_ON_DELIVERY"
                  :label="item.payment_method"
                  :value="item.id"
                  :key="item.id"
                  :disabled="checkDisablePaymentMethod(item)"
                >
                  <div class="flex flex-col lg:items-center lg:flex-row lg:justify-between">
                    <p class="lg:w-1/2">{{ item.payment_method }}</p>
                    <p v-if="checkDisablePaymentMethod(item)" class="text-red-150 text-xs">
                      {{
                        $t('common.paymentMethod.noteRuleMax', {
                          total: $n(item.rule_max / Constants.MAN_TO_YEN_CURRENCY, 'numeral', 'ja-JP'),
                        })
                      }}
                    </p>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <payment-info-item
              v-if="isCreditCard && creditCardCurrent"
              :card-number="creditCardCurrent.card_no"
              :month="creditCardCurrent.expire.split(/([\d]{2})([\d]{2})/)[2]"
              :year="creditCardCurrent.expire.split(/([\d]{2})([\d]{2})/)[1]"
            ></payment-info-item>

            <div v-if="isCreditCard && !creditCardCurrent">
              <el-form-item :label="$t('ec-line013.form.label.cardNumber')" prop="card_number">
                <el-input
                  inputmode="numeric"
                  v-model="paymentForm.card_number"
                  :placeholder="$t('ec-line013.form.placeholder.cardNumber')"
                  :maxlength="19"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('ec-line013.form.label.dateOfExpiry')" required>
                <el-row type="flex" align="middle">
                  <el-col :span="11">
                    <el-form-item prop="expiry_month">
                      <el-input
                        inputmode="numeric"
                        v-model="paymentForm.expiry_month"
                        :placeholder="$t('ec-line013.form.placeholder.expiryMonth')"
                        :maxlength="2"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" class="justify-center">{{ $t('common.dateSeparator') }}</el-col>
                  <el-col :span="11">
                    <el-form-item prop="expiry_year">
                      <el-input
                        inputmode="numeric"
                        v-model="paymentForm.expiry_year"
                        :placeholder="$t('ec-line013.form.placeholder.expiryYear')"
                        :maxlength="2"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('ec-line013.form.label.cardHolder')" prop="card_holder">
                <el-input
                  v-model="paymentForm.card_holder"
                  :placeholder="$t('ec-line013.form.placeholder.cardHolder')"
                  :maxlength="50"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('ec-line013.form.label.securityCode')" prop="security_code">
                <el-input
                  inputmode="numeric"
                  v-model="paymentForm.security_code"
                  :placeholder="$t('common.pleaseEnter')"
                  type="text"
                  :maxlength="4"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <img :src="Constants.SHOP_CONFIG.BANK_CARD_URL" alt="card" />
              </el-form-item>
              <el-form-item :label="$t('ec-line013.form.label.numberOfPayment')" prop="number_of_payment">
                <el-select v-model="paymentForm.number_of_payment">
                  <el-option
                    v-for="item in NUMBER_OF_PAYMENT"
                    :key="item.id"
                    :value="item.id"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-show="isAmazon" class="section-amazon">
              <el-form-item v-show="isLoginAmazon">
                <p class="text-red">{{ paymentForm.amazonCard }}</p>
                <amazon-logout-button
                  class="mt-6"
                  @click="
                    onClickAmazonLogout(amazonProductType, ['#AmazonPayButton'], Constants.AMAZON.ACCESS_TOKEN_015)
                  "
                />
              </el-form-item>
              <div v-if="!isLoginAmazon" class="section-amazon__button">
                <div
                  id="AmazonPayButton"
                  class="section-amazon__button-login"
                  @click="(event) => handleAmazonButton(event, Constants.AMAZON.BACKUP_AMAPAY_015, true)"
                  :class="{ 'pointer-events-none': disableAmazon }"
                ></div>
                <div class="section-amazon__button-hint">{{ $t('common.amazonHint') }}</div>
              </div>
            </div>
          </el-form>
        </the-section>

        <the-section v-if="isOpenNoticeArrangedOrdersSection" class="notice-arranged-orders-section">
          <template #sub>
            <p class="whitespace-pre-line text-base text-red-150">
              {{ $t('ec-line015.unShipOrArrangedInfo.warningMsg1') }}
            </p>
            <p class="whitespace-pre-line text-base text-red-150 mt-2">
              {{ $t('ec-line015.unShipOrArrangedInfo.warningMsg2') }}
            </p>
            <p class="whitespace-pre-line text-base mt-2">
              {{ $t('ec-line015.unShipOrArrangedInfo.sectionMsg') }}
            </p>
            <p class="whitespace-pre-line text-center shop-phone-number-text-style mt-2">
              {{ getShopPhoneNumber }}
            </p>
            <p class="whitespace-pre-line text-center text-base">
              {{ getShopBusinessHour }}
            </p>
          </template>
        </the-section>
      </el-form>

      <div class="flex flex-wrap justify-center mt-5 lg:mt-10 lg:mb-4">
        <el-button
          class="submit-btn lg:ml-6 lg:order-1"
          :disabled="(form && isEmpty(form.subscription_order_item)) || lumpSumValidFlag || !summaryStatus"
          @click="onSubmit(isPausing)"
        >
          {{ isPausing ? $t('ec-line015.content.checkReopen') : $t('ec-line015.content.checkTheChanges') }}
        </el-button>
        <el-button class="cancel-btn mt-5 mb-1 lg:my-0" @click="toSubscriptionList">{{
          $t('common.action.cancel')
        }}</el-button>
      </div>

      <address-dialog
        :visible.sync="addressDialog"
        :subscription-id="id"
        :data="addresses"
        request-update-customer-address
        v-model="addressId"
        @updated-address="fetchAddress"
      />
      <card-dialog
        :visible.sync="cardDialog"
        :data="cards"
        v-model="cardSeq"
        :loading="cartListLoading"
        @reload-list="fetchCardList"
        @change="onChangePaymentMethod"
      />

      <cancel-subscription-dialog
        :visible.sync="cancelSubscriptionVisible"
        :cancellation-reasons="cancellationReasons"
        :cancel-content="confirmCancelSubscriptionContent"
        @on-cancel-subscription="onCancelSubscription"
        @scroll-purchaseDetails="scrollPurchaseDetails"
        @scroll-subscription="scrollSubscription"
      />

      <prompt-dialog
        v-if="isShowPopup"
        :visible.sync="visibleConfirmDialog"
        :title="$t('ec-line015.dialog.title')"
        @on-cancel="handleCancel()"
      >
        <template #content>
          <div class="mx-auto text-left max-w-3xl">
            <p :class="['mt-10', !(isOriginNDDLessThanMinDeliveryDate || isOriginNNDDPast) ? 'mb-10' : '']">
              {{ $t('ec-line015.dialog.content') }}
            </p>
            <p
              v-if="
                (isOriginNDDLessThanMinDeliveryDate && !unableChangeNextDelivery) ||
                isOriginNNDDPast ||
                !form.payment_service_id
              "
              class="mt-6 mb-10 text-red-150 flex flex-col gap-4"
            >
              <span v-if="isOriginNDDLessThanMinDeliveryDate && !unableChangeNextDelivery">
                {{
                  $t('ec-line015.dialog.contentNDDIsPass', {
                    minDeliveryDate: Utils.date.getDateString(deliveryMinDate, Constants.FORMAT_DATE),
                  })
                }}
              </span>
              <span v-if="isOriginNNDDPast">{{ $t('ec-line015.dialog.contentNNDDIsPass') }}</span>
              <span v-if="!form.payment_service_id">{{ $t('ec-line015.dialog.contentChangePaymentToNP') }}</span>
            </p>
          </div>
        </template>
      </prompt-dialog>

      <confirm-dialog-2
        class="pause-subscription"
        :visible.sync="pauseSubscriptionVisible"
        :title="$t('ec-line015.content.pauseSection.confirmPauseTitle')"
      >
        <template #content>
          <div>
            <pre class="pause-subscription__font whitespace-pre-line text-left text-base">
              {{ confirmPauseSubscriptionContent }}
            </pre>
          </div>
        </template>
        <template slot="action">
          <div class="flex flex-col lg:flex-row gap-5 justify-center items-center">
            <el-button class="confirm-dialog-2__btn submit-btn" @click="onAcceptPauseSubscription">
              {{ $t('common.label.yes') }}
            </el-button>
            <el-button class="confirm-dialog-2__btn cancel-btn mt-0" @click="onCancelDialogPause">
              {{ $t('common.label.no') }}
            </el-button>
          </div>
        </template>
      </confirm-dialog-2>

      <confirm-dialog-2
        class="cannot-pause-subscription-daialog"
        :visible.sync="cannotPauseSubscriptionVisible"
        :title="$t('ec-line015.content.pauseSection.cannotConfirmPauseTitle')"
      >
        <template #content>
          <div>
            <pre class="cannot-pause-subscription-daialog__font whitespace-pre-line text-left text-base my-5 lg:my-10">
              {{ $t('ec-line015.content.pauseSection.cannotConfirmPauseContent') }}
            </pre>
          </div>
        </template>
        <template slot="action">
          <div class="flex justify-center items-center">
            <el-button class="confirm-dialog-2__btn cancel-btn mt-0" @click="cannotPauseSubscriptionVisible = false">
              {{ $t('common.action.close') }}
            </el-button>
          </div>
        </template>
      </confirm-dialog-2>

      <prompt-dialog
        :visible.sync="visibleChangePaymentDialog"
        :title="changePaymentDialogTitle"
        @on-cancel="visibleChangePaymentDialog = false"
      >
        <template #content>
          <div class="mb-10 mt-8 lg:mt-10 lg:text-center">
            <p
              v-for="(content, index) in changePaymentDialogContent"
              :key="index"
              class="mt-2 lg:mt-0 lg:whitespace-pre-line"
            >
              {{ content }}
            </p>
            <p v-if="showPaymentWarningMsg" class="text-red mt-6">
              {{
                $t('ec-line015.changePaymentDialog.warningMsg', {
                  nextDeliveryDate: Utils.date.getDateString(
                    subscriptionPatternForm.next_delivery_date,
                    Constants.FORMAT_DATE
                  ),
                })
              }}
            </p>
          </div>
        </template>
      </prompt-dialog>

      <prompt-dialog
        custom-title-class="text-center"
        :visible="
          ((batchError.code !== '' && batchError.code !== null) || batchErrorType) && !isNDDGreaterThan9DateFromToday
        "
        :title="$t('ec-line014.paymentDialog.title')"
      >
        <template #content>
          <div class="whitespace-pre-wrap my-10 mx-auto max-w-3xl">
            {{
              $t('ec-line014.paymentDialog.content', {
                delivery_date: Utils.date.getDateString(
                  dataSubscriptionPatternInitial.next_delivery_date,
                  Constants.FORMAT_DATE
                ),
              })
            }}
          </div>
        </template>
        <template #action>
          <div class="text-center">
            <el-button class="submit-btn" @click="toCpayPage">{{ $t('ec-line014.cart.changePaymentBtn') }}</el-button>
          </div>
        </template>
      </prompt-dialog>

      <prompt-dialog
        :visible.sync="visibleUnshipOrArrangedDialog"
        :title="$t('ec-line015.unShipOrArrangedInfo.title')"
        @on-cancel="visibleUnshipOrArrangedDialog = false"
      >
        <template #content>
          <div class="my-10">
            <pre class="whitespace-pre-line text-left text-red font-bold">
              {{ $t('ec-line015.unShipOrArrangedInfo.warningMsg1') }}
              {{ $t('ec-line015.unShipOrArrangedInfo.warningMsg2') }}
            </pre>
          </div>
        </template>
      </prompt-dialog>
    </div>
  </div>
</template>

<script>
import amazonMixin from '@/mixins/amazonV2'
import deliveryPatternMixin from '@/mixins/deliveryPattern'
import deliveryNoteMixin from '@/mixins/deliveryNote'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import TheSection from '@/components/my-page-partials/TheSection.vue'
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import CartListItem from '@/components/ec-line015/CartListItem.vue'
import CartTotal from '@/components/CartTotal.vue'
import AddressInfoItem from '@/components/AddressInfoItem.vue'
import PaymentInfoItem from '@/components/PaymentInfoItem.vue'
import AddressDialog from '@/components/AddressDialog.vue'
import AmazonLogoutButton from '@/components/AmazonLogoutButton.vue'
import CardDialog from '@/components/CardDialog.vue'
import CancelSubscriptionDialog from '@/components/ec-line015/CancelSubscriptionDialog.vue'
import ConfirmDialog2 from '@/components/ConfirmDialog2.vue'
import PromptDialog from '@/components/PromptDialog.vue'
import DisabledInput from '@/components/DisabledInput.vue'
import { NUMBER_OF_PAYMENT } from '@/mocks/ec-line013'
import {
  AddressService,
  MyPageService,
  PaymentService,
  SubscriptionService,
  MasterService,
  OrderService,
  DeliveryService,
} from '@/services'
import { ENV_KEY } from '@/constants/env'
import { isEmpty, isNil, cloneDeep } from 'lodash'
import BaseCheckbox from '@/components/partials/baseCheckBox'
import BaseDatePicker from '@/components/partials/baseDatepicker'
import { NEXT_NEXT_DIFF_MIN_DATE, DIFF_MIN_NDD, CARD_DEFAULT_FLAG, SPECIAL_PRODUCT_NAMES } from '@/constants'
import { AMAZON } from '@/constants/amazon'
import { syncSubscriptionItems } from '@/utils'
import deliveryFeeOptimizationMixin from '@/mixins/deliveryFeeOptimization'

export default {
  components: {
    TheHeading,
    TheSection,
    CartListItem,
    CartTotal,
    AddressInfoItem,
    PaymentInfoItem,
    AddressDialog,
    CardDialog,
    AmazonLogoutButton,
    CancelSubscriptionDialog,
    ConfirmDialog2,
    PromptDialog,
    BaseCheckbox,
    BaseDatePicker,
    DisabledInput,
  },
  mixins: [amazonMixin, deliveryPatternMixin, deliveryNoteMixin, BreadcrumbMixin, deliveryFeeOptimizationMixin],
  props: {
    id: {
      type: String,
      default: () => '',
    },
    subscriptionNo: {
      type: [String, Number],
      default: () => '',
    },
    section: {
      type: String,
      default: () => '',
    },
    isShowPopup: { type: Boolean, default: false },
    isAutoCalcShipping: { type: Boolean, default: false },
  },
  data() {
    const popupName = this.$route.query.popup

    const isPopupName = popupName && Object.values(this.Constants.POPUP_NAME).includes(popupName)

    return {
      visibleConfirmDialog: false,
      rules: {
        card_number: [
          this.Utils.validate.required(this.$t('common.validate.field.cardNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.cardNumber')),
        ],

        security_code: [
          this.Utils.validate.required(this.$t('ec-line013.form.label.securityCode')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.securityCode')),
        ],

        expiry_month: [
          this.Utils.validate.required(this.$t('common.validate.field.dateOfExpiredMonth')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.dateOfExpiredMonth')),
          this.Utils.validate.numberBetween(this.$t('common.validate.field.dateOfExpiredMonth'), 1, 12),
        ],

        expiry_year: [
          this.Utils.validate.required(this.$t('common.validate.field.dateOfExpiredYear')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.dateOfExpiredYear')),
          this.Utils.validate.numberBetween(
            this.$t('common.validate.field.dateOfExpiredYear'),
            new Date().getFullYear().toString().slice(-2),
            (new Date().getFullYear() + 10).toString().slice(-2)
          ),
        ],

        number_of_payment: [this.Utils.validate.required(this.$t('common.validate.field.numberOfPayment'))],

        payment_id: [this.Utils.validate.requiredSelect(this.$t('common.validate.field.methodOfPayment'))],
        next_delivery_date: [
          {
            validator: (rule, value, callback) => {
              const nextDeliveryDate = this.$date.startOfDay(new Date(value))
              const nextNextDeliveryDate = this.$date.startOfDay(
                new Date(this.subscriptionPatternForm.next_next_delivery_date)
              )
              const diffDate = this.$date.differenceInDays(nextNextDeliveryDate, nextDeliveryDate)
              const diffMinNDD = this.$date.differenceInDays(nextDeliveryDate, this.$date.startOfToday())

              // 出荷手配済みの受注がある定期は、次回配送日を過去日でも変更できない為、バリデーション対象外
              if (this.hasShipArrangedOrder) {
                callback()
              }

              if (diffMinNDD < 0) {
                callback(
                  new Error(this.$t('ec-line015.content.subscriptionValidate.nextDeliveryDateIsPast').toString())
                )
              } else if (this.$date.isBefore(nextNextDeliveryDate, nextDeliveryDate)) {
                callback(new Error(this.$t('ec-line015.content.subscriptionValidate.nextnextBeforeNext').toString()))
              } else if (diffDate < NEXT_NEXT_DIFF_MIN_DATE) {
                callback(new Error(this.$t('ec-line015.content.subscriptionValidate.diffMin10Day').toString()))
              } else if (diffMinNDD > DIFF_MIN_NDD || diffDate > DIFF_MIN_NDD) {
                callback(
                  new Error(this.$t('ec-line015.content.subscriptionValidate.nextnextMoreThan100date').toString())
                )
              } else {
                callback()
              }
            },
            trigger: [],
          },
        ],
        next_next_delivery_date: [
          {
            validator: (rule, value, callback) => {
              const nextDeliveryDate = this.$date.startOfDay(new Date(this.subscriptionPatternForm.next_delivery_date))
              const nextNextDeliveryDate = this.$date.startOfDay(new Date(value))
              const diffDate = this.$date.differenceInDays(nextNextDeliveryDate, nextDeliveryDate)
              const diffMinNNDD = this.$date.differenceInDays(nextNextDeliveryDate, this.$date.startOfToday())

              if (diffMinNNDD < 0) {
                callback(
                  new Error(this.$t('ec-line015.content.subscriptionValidate.nextNextDeliveryDateIsPast').toString())
                )
              } else if (this.$date.isBefore(nextNextDeliveryDate, nextDeliveryDate)) {
                callback(new Error(this.$t('ec-line015.content.subscriptionValidate.nextnextBeforeNext').toString()))
              } else if (diffDate < NEXT_NEXT_DIFF_MIN_DATE) {
                callback(new Error(this.$t('ec-line015.content.subscriptionValidate.diffMin10Day').toString()))
              } else if (diffDate > DIFF_MIN_NDD) {
                callback(
                  new Error(this.$t('ec-line015.content.subscriptionValidate.nextnextMoreThan100date').toString())
                )
              } else {
                callback()
              }
            },
            trigger: [],
          },
        ],
      },

      addressDialog: isPopupName && popupName === this.Constants.POPUP_NAME.ADDRESS,
      addresses: [],
      addressId: null,
      shopPaymentMethods: [],
      loading: false,
      cards: [],
      cardDialog: isPopupName && popupName === this.Constants.POPUP_NAME.CARD,
      cardSeq: null,
      NUMBER_OF_PAYMENT,
      paymentForm: {
        amazonCard: null,
        payment_id: null,
        card_number: null,
        expiry_month: null,
        expiry_year: null,
        card_holder: null,
        security_code: null,
        number_of_payment: this.Constants.NUMBER_OF_PAYMENT.BULK,
      },
      subscriptionPatternForm: {
        param1_1: null,
        param1_2: null,
        param2_1: null,
        param2_2: null,
        param2_3: null,
        param3_1: null,
        subscription_division_id: null,
        autoCalcLastDeliveryDate: true,
        autoCalcLastDeliveryDate2: true,
        next_delivery_date: null,
        next_next_delivery_date: null,
        time_id: null,
      },
      originSubscriptionPatternForm: {
        param1_1: null,
        param1_2: null,
        param2_1: null,
        param2_2: null,
        param2_3: null,
        param3_1: null,
        subscription_division_id: null,
        autoCalcLastDeliveryDate: true,
        autoCalcLastDeliveryDate2: true,
        next_delivery_date: null,
        next_next_delivery_date: null,
        time_id: null,
      },
      cancelSectionVisible: false,
      cancelSubscriptionVisible: false,
      cancellationReasons: [],
      isPeriodic: true,
      scroll: '',
      pauseSubscriptionVisible: false,
      cannotPauseSubscriptionVisible: false,
      dataUpdateSubscription: {},
      subscriptionOrderItemInitial: [],
      customerAddressIdInitial: '',
      dataSubscriptionPatternInitial: {},
      deliveryMinDate: null,
      disableForm: false,
      isAvailableTimezone: false,
      deliveryTimezones: [],
      deliveryMethodList: [],
      batchError: {
        is_payment_error_in_btc1: false,
        is_payment_error_in_btc6: false,
        is_payment_error_in_btc7: false,
        delivery_date: null,
        code: '',
      },
      visibleChangePaymentDialog: false,
      changePaymentDialogTitle: '',
      changePaymentDialogContent: [],
      showPaymentWarningMsg: false,
      isLogoutAmazon: false,
      cartListLoading: false,
      hasUnshipOrder: false,
      hasShipArrangedOrder: false,
      visibleUnshipOrArrangedDialog: false,
      isOpenNoticeArrangedOrdersSection: false,
      deliveryFeeRequestFlag: false,
      visibleProducts: true,
      placeholderLabel: '',
      deliveryDivisionId: null,
      coolingOffFlag: false,
      bundlePossibleFlag: false,
      deliveryDivisionName: '',
      isNotBundledRemoteIsland: false,
      deliveryId: null,
    }
  },
  computed: {
    subTotal() {
      return Number(this.form.subtotal)
    },
    subDiscount() {
      return Number(this.form.discount_amount)
    },
    deliveryFee() {
      return Number(this.form.delivery_fee)
    },
    tax() {
      return Number(this.form.tax_total)
    },
    totalAmount() {
      return Number(this.form.payment_total)
    },
    summaryStatus() {
      return this.form.summary_status
    },
    flatDeliveryFee() {
      const deliveryMethod = this.deliveryMethodList.find((item) => item.delivery_id === this.form?.delivery_id)
      return deliveryMethod?.flat_rate_delivery_fee || null
    },
    deliveryMethodText() {
      return this.deliveryDivisionName || ''
    },
    form: {
      get() {
        return this.$store.getters['subscription/getSubscription']
      },
      set(val) {
        this.$store.commit('subscription/UPDATE_SUBSCRIPTION', val)
      },
    },
    subscriptionItems() {
      return (
        this.form?.subscription_order_item?.map((i) =>
          Object.assign({
            id: i.id,
            price: Number(i.price),
            name: i.product_name,
            product_image: i.product_image,
            quantity: Number(i.quantity),
            sku_item_parent_name_1: i.sku_item_parent_name_1,
            sku_item_parent_name_2: i.sku_item_parent_name_2,
            sku_set_item_name1: i.sku_set_item_name1,
            sku_set_item_name2: i.sku_set_item_name2,
            product_id: i.product_id,
            sale_limit: i.sale_limit,
            discount_amount: Number(i.discount_amount),
            subtotal: Number(i.subtotal),
            discount_amount_total: Number(i.discount_amount_total),
            lump_sum_payment_flag: i.lump_sum_payment_flag,
            lump_sum_payment_num: i.lump_sum_payment_num,
            tax: Number(i.tax),
            tax_rate: i.tax_rate,
            product_sku_id: i.product_sku_id,
            product_code: i.product_code,
            is_out_stock: i.is_out_stock || true,
          })
        ) || []
      )
    },
    confirmSubscription() {
      return this.$store.getters['subscription/getConfirmSubscription']
    },
    customer_address() {
      const address = this.addresses.find((address) => address.id === this.addressId)
      return address || this.form.customer_address
    },
    prefecture_text() {
      return (
        this.customer_address?.pref?.name ||
        this.prefectures?.find((pref) => pref.id === this.customer_address?.pref.id)?.name ||
        ''
      )
    },
    isCreditCard() {
      return (
        this.shopPaymentMethods.find((i) => i.id === this.paymentForm.payment_id)?.payment_service_id ===
        this.Constants.PAYMENT_METHOD.CREDIT_CARD
      )
    },
    isFirstCreditCard() {
      return this.isCreditCard && !this.cards.length
    },
    isCreditCardWithoutCard() {
      return this.isCreditCard && this.cards.length && [undefined, null].includes(this.cardSeq)
    },
    isAmazon() {
      return (
        this.shopPaymentMethods.find((i) => i.id === this.paymentForm.payment_id)?.payment_service_id ===
        this.Constants.PAYMENT_METHOD.AMAZON
      )
    },
    isCurrentAmazon() {
      return this.form.payment_service_id === this.Constants.PAYMENT_METHOD.AMAZON
    },
    ruleMaxAmazon() {
      return this.shopPaymentMethods.find((i) => i.payment_service_id === this.Constants.PAYMENT_METHOD.AMAZON)
        ?.rule_max
    },
    hintAmazon() {
      return !this.totalAmount
        ? this.$t('common.amazon.zeroYenHint')
        : this.$t('common.amazon.hint', {
            total: this.$n(this.ruleMaxAmazon / this.Constants.MAN_TO_YEN_CURRENCY, 'numeral', 'ja-JP'),
          })
    },
    creditCardCurrent() {
      return (
        this.cards.find((i) => i.card_seq === this.cardSeq) ||
        this.cards.find((i) => i.default_flag === CARD_DEFAULT_FLAG.DEFAULT) ||
        this.cards[0]
      )
    },
    disableAmazon() {
      return (
        (this.ruleMaxAmazon !== null && this.totalAmount > this.ruleMaxAmazon) ||
        !this.totalAmount ||
        (this.disableForm && this.disableFormByDateAndStatus)
      )
    },
    isHokkaido() {
      return this.form.customer_address?.pref.id === this.Constants.HOKKAIDO_ID
    },
    pickerOptions1() {
      if (this.batchError.is_payment_error_in_btc1) {
        const minDeliveryDate = this.$date.startOfDay(this.deliveryMinDate)
        const maxDeliveryDate = this.$date.add(this.$date.startOfToday(), { days: 9 })

        if (minDeliveryDate.getTime() < maxDeliveryDate.getTime()) {
          return {
            disabledDate: (time) =>
              this.$date.isBefore(this.$date.startOfDay(time), minDeliveryDate) ||
              this.$date.isAfter(this.$date.startOfDay(time), maxDeliveryDate),
          }
        } else {
          return { disabledDate: (time) => this.$date.startOfDay(time).getTime() !== minDeliveryDate.getTime() }
        }
      }
      return {
        disabledDate: (time) => {
          const startDate = this.$date.getTime(
            this.$date.add(this.$date.startOfDay(this.deliveryMinDate || new Date()), {
              days: this.deliveryMinDate ? 0 : 5,
            })
          )
          const next100day = this.$date.getTime(
            this.$date.add(this.$date.startOfToday(), {
              days: DIFF_MIN_NDD,
            })
          )
          return this.$date.startOfDay(time).getTime() < startDate || this.$date.startOfDay(time).getTime() > next100day
        },
      }
    },
    pickerOptions2() {
      const nextDate = this.$date.startOfDay(new Date(this.subscriptionPatternForm.next_delivery_date))
      const startDate = this.$date.getTime(
        this.$date.add(nextDate, {
          days: NEXT_NEXT_DIFF_MIN_DATE,
        })
      )
      const next100date = this.$date.getTime(
        this.$date.add(nextDate, {
          days: DIFF_MIN_NDD,
        })
      )

      return {
        disabledDate: (time) =>
          this.$date.startOfDay(time).getTime() < startDate || this.$date.startOfDay(time).getTime() > next100date,
      }
    },
    confirmCancelSubscriptionContent() {
      return this.form?.disable_next_delivery
        ? `${this.$t('ec-line015.content.cancelSection.confirmCancelSubscriptionDialogContent1', {
            date: this.Utils.date.formatMonthDateJS(this.subscriptionPatternForm.next_next_delivery_date),
          })}\n${this.$t('ec-line015.content.cancelSection.confirmCancelSubscriptionDialogContent2', {
            date: this.Utils.date.formatMonthDateJS(this.subscriptionPatternForm.next_delivery_date),
          })}`
        : `${this.$t('ec-line015.content.cancelSection.confirmCancelSubscriptionDialogContent1', {
            date: this.Utils.date.formatMonthDateJS(this.subscriptionPatternForm.next_delivery_date),
          })}`
    },
    hasPauseFlag() {
      return this.$store.getters['auth/shop'].pause_flag
    },
    hasCancelFlag() {
      return this.$store.getters['auth/shop'].cancellation_flag
    },
    isPausing() {
      return this.form.status_id === this.Constants.SUBSCRIPTION_STATUS.PAUSE
    },
    isCanceling() {
      return this.form.status_id === this.Constants.SUBSCRIPTION_STATUS.CANCEL
    },
    titlePauseOrCancelSection() {
      if (this.hasPauseFlag && this.hasCancelFlag && !this.isPausing) {
        return this.$t('ec-line015.content.cancelAndPauseSection.title')
      }

      return !this.isPausing && this.hasPauseFlag
        ? this.$t('ec-line015.content.pauseSection.title')
        : this.$t('ec-line015.content.cancelSection.title')
    },
    descriptionPauseOrCancelSection() {
      if (this.hasPauseFlag && this.hasCancelFlag && !this.isPausing) {
        return this.$t('ec-line015.content.cancelAndPauseSection.description')
      }

      return !this.isPausing && this.hasPauseFlag
        ? this.$t('ec-line015.content.pauseSection.description')
        : this.$t('ec-line015.content.cancelSection.description')
    },
    confirmPauseSubscriptionContent() {
      if (isEmpty(this.dataSubscriptionPatternInitial)) return ''
      return this.hasUnshipOrder || this.hasShipArrangedOrder
        ? `${this.$t('ec-line015.content.pauseSection.confirmPauseSubscriptionDialogContent1', {
            date: this.Utils.date.formatMonthDateJS(this.dataSubscriptionPatternInitial.next_next_delivery_date),
          })}\n${this.$t('ec-line015.content.pauseSection.confirmPauseSubscriptionDialogContent2', {
            date: this.Utils.date.formatMonthDateJS(this.dataSubscriptionPatternInitial.next_delivery_date),
          })}`
        : `${this.$t('ec-line015.content.pauseSection.confirmPauseSubscriptionDialogContent1', {
            date: this.Utils.date.formatMonthDateJS(this.dataSubscriptionPatternInitial.next_delivery_date),
          })}`
    },
    deliveryTimezoneText() {
      return this.subscriptionPatternForm.time_id
        ? this.deliveryTimezones.find((i) => i.value === this.subscriptionPatternForm.time_id).label
        : this.isAvailableTimezone
        ? this.$t('common.placeholder.unspecified')
        : this.$t('common.placeholder.unavailableTimeZone')
    },
    isIncludedDeliveryNotes() {
      return this.deliveryNotes.find((i) => i.value === this.form.delivery_note_id)
    },
    batchErrorType() {
      const errorType = {
        [[true, false, false]]: this.$t('ec-line014.cart.error.batch1', {
          delivery_date: this.Utils.date.getDateString(this.batchError.delivery_date, this.Constants.FORMAT_DATE),
        }),
        [[false, true, false]]: this.$t('ec-line014.cart.error.batch6', {
          delivery_date: this.Utils.date.getDateString(this.batchError.delivery_date, this.Constants.FORMAT_DATE),
        }),
        [[false, false, true]]: this.$t('ec-line014.cart.error.batch7', {
          delivery_date: this.Utils.date.getDateString(this.batchError.delivery_date, this.Constants.FORMAT_DATE),
        }),
      }

      return (
        errorType[
          [
            this.batchError.is_payment_error_in_btc1,
            this.batchError.is_payment_error_in_btc6,
            this.batchError.is_payment_error_in_btc7,
          ]
        ] || !1
      )
    },
    isNDDLessThanMinDeliveryDate() {
      const minDeliveryDate = this.$date.startOfDay(this.deliveryMinDate)
      const nextDeliveryDate = this.$date.startOfDay(new Date(this.subscriptionPatternForm.next_delivery_date))
      return this.$date.isBefore(nextDeliveryDate, minDeliveryDate)
    },
    isNDDGreaterThan9DateFromToday() {
      return this.$date.isAfter(
        this.$date.startOfDay(new Date(this.subscriptionPatternForm.next_delivery_date)),
        this.$date.add(this.$date.startOfToday(), { days: 9 })
      )
    },
    isOriginNNDDPast() {
      const minDeliveryDate = this.$date.startOfDay(this.deliveryMinDate)
      const nextNextDeliveryDate = this.$date.startOfDay(
        new Date(this.originSubscriptionPatternForm.next_next_delivery_date)
      )
      return this.$date.isBefore(nextNextDeliveryDate, minDeliveryDate)
    },
    isOriginNDDLessThanMinDeliveryDate() {
      const minDeliveryDate = this.$date.startOfDay(this.deliveryMinDate)
      const nextDeliveryDate = this.$date.startOfDay(new Date(this.originSubscriptionPatternForm.next_delivery_date))
      return this.$date.isBefore(nextDeliveryDate, minDeliveryDate)
    },
    isReopenOnTheDay() {
      if (this.form.reopen_date !== null) {
        const reopenDate = this.$date.startOfDay(this.form.reopen_date)
        const today = this.$date.startOfToday()
        return this.$date.isEqual(reopenDate, today)
      }
      return false
    },
    disableFormByDateAndStatus() {
      return !this.isPausing && !this.isCanceling && !this.isReopenOnTheDay
    },
    disableNextDeliveryForm() {
      return (
        (this.disableForm && this.disableFormByDateAndStatus) ||
        (this.disableForm && this.hasUnshipOrder) ||
        this.hasShipArrangedOrder
      )
    },
    unableChangeNextDelivery() {
      return (this.disableForm && this.hasUnshipOrder) || this.hasShipArrangedOrder
    },
    disableDeleteProducts() {
      return this.subscriptionItems.length <= 1
    },
    freeAmount() {
      return this.$store.getters['cart/freeAmount']
    },
    hasLumpSumPayment() {
      return this.subscriptionItems.some((item) => item.lump_sum_payment_flag)
    },
    lumpSumValidFlag() {
      return (
        this.subscriptionItems.some((i) => i.lump_sum_payment_flag) &&
        !this.subscriptionItems.every(
          (i) => i.lump_sum_payment_flag && i.lump_sum_payment_num === this.subscriptionItems[0].lump_sum_payment_num
        )
      )
    },
    isTimeIdValid() {
      return this.deliveryTimezones.some((item) => item.value === this.subscriptionPatternForm.time_id && item.visible)
    },
    filteredDeliveryTime() {
      return this.deliveryTimezones.filter((item) => item.visible)
    },
    hasNomuSilicaLightProduct() {
      return this.subscriptionItems.some(
        (item) => item.name && item.name.includes(SPECIAL_PRODUCT_NAMES.NOMU_SILICA_LIGHT)
      )
    },
    isBundledFlagDisabled() {
      return this.isNotBundledRemoteIsland || this.hasNomuSilicaLightProduct
    },
    getShopPhoneNumber() {
      return this.Utils.helper.formatPhoneNumber(this.$store.getters['auth/shop'].phone_number)
    },
    getShopBusinessHour() {
      return this.$store.getters['auth/shop'].business_hour
    },
    hasCorporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
    fullName() {
      const storeName = this.hasCorporateFlag ? this.customer_address.store_name : ''
      return storeName + ' ' + this.Utils.helper.fullName(this.customer_address.name01, this.customer_address.name02)
    },
    visible_bundled_flag() {
      return this.$store.getters['auth/shop'].visible_bundled_flag
    },
  },
  watch: {
    deliveryFee: {
      handler(val) {
        if (!this.isAutoCalcShipping) return
        this.form.delivery_fee = val
      },
      immediate: true,
    },
    subTotal: {
      handler() {
        if (!this.isAutoCalcShipping) return
        this.form.delivery_fee = this.deliveryFee
      },
      immediate: true,
    },
    isCreditCard: {
      handler(val) {
        if (val) {
          if (this.cardSeq === null && this.creditCardCurrent) {
            this.cardSeq = this.creditCardCurrent.card_seq
          }
        }
      },
      immediate: true,
    },
    isLoginAmazon(val) {
      if (!val) {
        this.paymentForm.amazonCard = null
      }
    },
    customer_address: {
      async handler(value) {
        await this.updateAddress()
        await this.getDeliveryMethod(value.postal_code, value.pref.id)
      },
      deep: true,
    },
    'paymentForm.payment_id'() {
      this.handleChangeTotalOrPaymentId()
    },
    totalAmount() {
      this.handleChangeTotalOrPaymentId()
    },
    deliveryTimezones() {
      this.placeholderLabel = this.getDisplayedLabel(this.subscriptionPatternForm.time_id)
    },
    subscriptionItems: {
      handler() {
        this.checkBundledFlagByProduct()
      },
      deep: true,
    },
    'form.bundled_flag'() {
      this.getDeliveryMethod(this.form.customer_address.postal_code, this.form.customer_address.pref.id)
    },
  },
  created() {
    this.loading = true
    this.visibleProducts = false

    this.initAmazonSessionId(AMAZON.ACCESS_TOKEN_015)
      .then(({ isLogoutAmazon }) => {
        this.$nextTick(() => {
          this.isLogoutAmazon = isLogoutAmazon
        })
      })
      .then(() => this.fetchDataSubscription(true))
      .then(() => {
        if (this.$session[AMAZON.BACKUP_AMAPAY_015]) {
          const backupForm = JSON.parse(this.$session[AMAZON.BACKUP_AMAPAY_015])
          this.form = cloneDeep(backupForm)
          this.$session[AMAZON.BACKUP_AMAPAY_015] = null
        }

        if (!this.disableForm && (this.hasUnshipOrder || this.hasShipArrangedOrder)) {
          this.visibleUnshipOrArrangedDialog = true
          this.isOpenNoticeArrangedOrdersSection = true
        }
      })
      .then(() => this.cloneForm())
      .then(() => this.fetchData())
      .then(() =>
        this.initGetDeliveryMethod(this.form.customer_address.postal_code, this.form.customer_address.pref.id)
      )
      .catch(() => {
        this.loading = false
        this.visibleProducts = true
      })
  },
  mounted() {
    // this.amazonWidgetRender()
    this.getAmazonButton(process.env.VUE_APP_AMAZON_PRODUCT_TYPE_PAY_ONLY)
      .then(() => this.getAmazonShiping(AMAZON.ACCESS_TOKEN_015))
      .then(({ data }) => {
        if (data) {
          this.fillAmazonPaymentInfo(data, this.paymentForm, false)
        }
      })
      .then(() => {
        this.$nextTick(() => {
          this.bindingAction('changeCustomerPayment', this.form, AMAZON.ACCESS_TOKEN_015, AMAZON.BACKUP_AMAPAY_015)
        })
      })
  },
  methods: {
    businessAccountFlag() {
      return this.$store.getters['auth/user']?.business_account_flag
    },
    handleCancel() {
      this.onChangePaymentMethods()
      this.$emit('update:isShowPopup', false)
    },
    isEmpty,
    fetchData() {
      // payment, addresses
      Promise.all([
        this.fetchAddress(),
        PaymentService.listMethod({}).then(({ data }) => (this.shopPaymentMethods = data)),
        this.fetchCardList(),
        MasterService.getTargetDetail('cancellation-reason').then(
          ({ data }) => (this.cancellationReasons = data[0].data)
        ),
      ])
        .then(() => this.resetDeliveryDateIfIsPauseOrCancel())
        .then(() => {
          return new Promise((resolve) => {
            this.$nextTick(() => {
              if (this.isLoginAmazon) {
                // this.refreshWidget()
                this.checkAmazonLogin()
              }

              if (this.isLogoutAmazon || this.isLoginAmazon) {
                this.onChangePaymentMethod(this.Constants.PAYMENT_DIALOG_TYPE.CHANGE_PAYMENT)
              }
              this.isLogoutAmazon = false
              resolve()
            })
          })
        })
        .then(() => this.resume())
        .then(() => this.handleChangeTotalOrPaymentId())
        .then(() => {
          this.deliveryFeeRequestFlag =
            (this.subTotal - this.subDiscount < this.freeAmount && Number(this.flatDeliveryFee) !== this.deliveryFee) ||
            (this.subTotal - this.subDiscount >= this.freeAmount && this.deliveryFee !== 0)
        })
        .then(() => syncSubscriptionItems(this.deliveryFeeRequestFlag))
        .then(() => this.verifyDeliveryPatternByLumpSumPayment())
        .finally(() => {
          let offsetTop
          if (this.section && this.$refs[this.section]) {
            offsetTop = this.$refs[this.section]?.offsetTop || this.$refs[this.section].$el.offsetTop
          }
          if (this.section === this.Constants.LIST_SECTION.SUBSCRIPTION_SECTION) {
            this.visibleConfirmDialog = true
          }
          if (
            this.section === this.Constants.LIST_SECTION.PAUSE_SECTION &&
            this.hasPauseFlag &&
            !this.hasCancelFlag &&
            this.disableForm &&
            this.disableFormByDateAndStatus
          ) {
            this.cannotPauseSubscriptionVisible = true
          }
          if (this.form.payment_service_id === this.Constants.PAYMENT_METHOD.CASH_ON_DELIVERY && this.isPausing) {
            this.visibleConfirmDialog = true
          }
          const query = { ...this.$route.query }
          query.section && delete query.section
          query.isAddProduct && delete query.isAddProduct

          this.$router.replace({ query }).then(() => {
            offsetTop && window.scroll({ behavior: 'smooth', top: offsetTop - 10 })
          })
          this.$emit('update:section', '')

          this.loading = false
          this.visibleProducts = true
          this.$emit('update:isAutoCalcShipping', true)
        })
    },

    fetchAddress() {
      return AddressService.getListAddress().then(({ data }) => (this.addresses = data))
    },
    fetchCardList() {
      this.cartListLoading = true
      return MyPageService.getCardList({ customer_id: this.$store.getters['auth/user'].id })
        .then(({ data }) => {
          this.cards = data.reverse()
        })
        .finally(() => (this.cartListLoading = false))
    },

    /**
     * 配送方法選択
     * @param deliveryId 配送方法ID
     */
    async selectDeliveryMethod(deliveryId, bundledAvailableFlag, postalCode, prefId) {
      await this.selectDeliveryFeeOptimization(deliveryId, this.paymentForm.payment_id, postalCode, prefId)
      // 配送方法
      this.form.delivery_id = this.selectedDeliveryMethod.delivery_id
      this.deliveryDivisionId = this.selectedDeliveryMethod.delivery_division_id
      this.deliveryDivisionName = this.selectedDeliveryMethod.delivery_division_name
      this.coolingOffFlag = this.selectedDeliveryMethod.cooling_off_flag

      // 支払方法
      this.shopPaymentMethods = this.selectedDeliveryMethod.payment || this.shopPaymentMethods
      this.form.payment_service_id = this.selectedDeliveryMethod.payment_id

      // 同梱可能配送会社フラグ
      this.isNotBundledRemoteIsland = !bundledAvailableFlag
      if (this.isNotBundledRemoteIsland) {
        this.form.bundled_flag = false
      }

      // 配送希望時間帯
      this.isAvailableTimezone = this.selectedDeliveryMethod.is_available_delivery_time
      this.deliveryTimezones = this.selectedDeliveryMethod.delivery_times
      if (!this.isAvailableTimezone) {
        this.subscriptionPatternForm.time_id = null
      }

      // 最短配送予定日
      this.deliveryMinDate = this.selectedDeliveryMethod.delivery_min_date
    },

    /**
     * 配送方法取得
     * @param postalCode 郵便番号
     * @param prefId 都道府県ID
     */
    async getDeliveryMethod(postalCode, prefId) {
      if (this.loading) return
      const loading = this.$loading({
        lock: true,
      })
      try {
        if (postalCode && prefId && postalCode.length === 8) {
          if (this.subscriptionItems.length <= 0) {
            return
          }
          // 配送費用最適化処理
          const params = {
            postal_code: postalCode,
            pref_id: prefId,
            business_account_flag: this.businessAccountFlag(),
            bundled_flag: this.form.bundled_flag,
            cooling_off_flag: false,
            order_item_list: this.subscriptionItems,
          }
          await this.getDeliveryFeeOptimization(params)
          if (this.optimizedDeliveryMethodList.delivery_methods.length > 0) {
            // 配送費用最適化配送業者リスト
            this.deliveryMethodList = this.optimizedDeliveryMethodList.delivery_methods
            const bundledAvailableFlag = this.optimizedDeliveryMethodList.bundled_available_flag
            // プロパティに配送方法各種情報設定 (delivery_methodsは基本最安値の配送会社1件)
            this.deliveryId = this.optimizedDeliveryMethodList.delivery_methods[0]?.delivery_id
            this.selectDeliveryMethod(this.deliveryId, bundledAvailableFlag, postalCode, prefId)
          }
        } else {
          this.deliveryMethodList = []
          this.deliveryTimezones = []
          this.shopPaymentMethods = []
          this.subscriptionPatternForm.time_id = null
          this.isNotBundledRemoteIsland = false
          this.form.bundled_flag = true
        }
      } catch (error) {
        this.deliveryMethodList = []
        this.deliveryTimezones = []
        this.shopPaymentMethods = []
        this.subscriptionPatternForm.time_id = null
        this.isNotBundledRemoteIsland = false
        this.form.bundled_flag = true
        this.handleError(error)
      } finally {
        loading.close()
      }
    },

    async initGetDeliveryMethod(postalCode, prefId) {
      if (postalCode && prefId && postalCode.length === 8) {
        if (this.subscriptionOrderItemInitial.length <= 0) {
          return
        }
        // 配送費用最適化処理
        const params = {
          postal_code: postalCode,
          pref_id: prefId,
          business_account_flag: this.businessAccountFlag(),
          bundled_flag: this.form.bundled_flag,
          cooling_off_flag: false,
          order_item_list: this.subscriptionOrderItemInitial,
        }
        await this.getDeliveryFeeOptimization(params)
        if (this.optimizedDeliveryMethodList.delivery_methods.length > 0) {
          const isSameDeliveryId =
            this.optimizedDeliveryMethodList.delivery_methods[0]?.delivery_id === this.form.delivery_id
          this.deliveryId = this.optimizedDeliveryMethodList.delivery_methods[0]?.delivery_id
          await this.selectDeliveryFeeOptimization(this.deliveryId, this.paymentForm.payment_id, postalCode, prefId)
          this.isAvailableTimezone = this.selectedDeliveryMethod.is_available_delivery_time
          this.deliveryTimezones = this.selectedDeliveryMethod.delivery_times
          if (!isSameDeliveryId || !this.isAvailableTimezone) {
            // 配送会社が異なる、または配送希望時間帯指定不可の場合はクリア
            this.subscriptionPatternForm.time_id = null
          }
        }
      }
    },

    checkAmazonLogin() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.restoreData()
          const amazonPayId = this.shopPaymentMethods.find(
            (i) => i.payment_service_id === this.Constants.PAYMENT_METHOD.AMAZON
          )?.id

          if (amazonPayId) {
            this.paymentForm.payment_id = amazonPayId
          }
          resolve()
        })
      })
    },
    resume() {
      const data = this.$store.getters['subscription/getConfirmSubscription']

      if (data) {
        this.paymentForm.payment_id = data.payment.payment_id

        if (this.isFirstCreditCard || this.isCreditCardWithoutCard) {
          this.paymentForm.card_number = data.payment.card_number
          this.paymentForm.expiry_month = data.payment.expiry_month
          this.paymentForm.expiry_year = data.payment.expiry_year
          this.paymentForm.card_holder = data.payment.card_holder
          this.paymentForm.security_code = data.payment.security_code
        }

        this.addressId = data.shipping.id

        // resume subscriptionForm
        this.subscriptionPatternForm.param1_1 = data.subscription_pattern.param1_1
        this.subscriptionPatternForm.param1_2 = data.subscription_pattern.param1_2
        this.subscriptionPatternForm.param2_1 = data.subscription_pattern.param2_1
        this.subscriptionPatternForm.param2_2 = data.subscription_pattern.param2_2
        this.subscriptionPatternForm.param2_3 = data.subscription_pattern.param2_3
        this.subscriptionPatternForm.param3_1 = data.subscription_pattern.param3_1
        this.subscriptionPatternForm.subscription_division_id = data.subscription_pattern.subscription_division_id
        this.subscriptionPatternForm.autoCalcLastDeliveryDate = data.subscription_pattern.autoCalcLastDeliveryDate
        this.subscriptionPatternForm.autoCalcLastDeliveryDate2 = data.subscription_pattern.autoCalcLastDeliveryDate2
        this.subscriptionPatternForm.next_delivery_date = data.subscription_pattern.next_delivery_date
        this.subscriptionPatternForm.next_next_delivery_date = data.subscription_pattern.next_next_delivery_date
        this.subscriptionPatternForm.time_id = data.time_id
      }
    },
    cloneForm() {
      if (isEmpty(this.form)) return

      this.addressId = this.form.customer_address.id

      this.cardSeq = !isNil(this.form.credit_card_registration_seq) ? `${this.form.credit_card_registration_seq}` : null

      this.paymentForm.payment_id = this.form.payment_id

      const val = this.form.subscription_delivery_pattern

      this.subscriptionPatternForm.subscription_division_id = val.subscription_division_id
      this.subscriptionPatternForm.next_delivery_date = val.next_delivery_date
      this.subscriptionPatternForm.next_next_delivery_date = val.next_next_delivery_date
      this.subscriptionPatternForm.autoCalcLastDeliveryDate =
        this.form.subscription_delivery_pattern.next_delivery_auto_calculation
      this.subscriptionPatternForm.autoCalcLastDeliveryDate2 =
        this.form.subscription_delivery_pattern.next_next_delivery_auto_calculation
      this.subscriptionPatternForm.time_id = this.form.time_id

      if (val.subscription_division_id === this.Constants.DELIVERY_PATTERN_CHANGE.MONTHLY_DATE_SPECIFICATION) {
        this.subscriptionPatternForm.param1_1 = val.param1
        this.subscriptionPatternForm.param1_2 = val.param2
        this.subscriptionPatternForm.param2_1 = this.monthly[0].value
        this.subscriptionPatternForm.param2_2 = this.weekNo[0].value
        this.subscriptionPatternForm.param2_3 = this.dayOfWeek[0].value
        this.subscriptionPatternForm.param3_1 = this.dayDaily[0].label
      } else if (val.subscription_division_id === this.Constants.DELIVERY_PATTERN_CHANGE.INTERVAL_DESIGNATION) {
        this.subscriptionPatternForm.param1_1 = this.monthly[0].value
        this.subscriptionPatternForm.param1_2 = this.dayInMonth[0].value
        this.subscriptionPatternForm.param2_1 = val.param1
        this.subscriptionPatternForm.param2_2 = val.param2
        this.subscriptionPatternForm.param2_3 = val.param3
        this.subscriptionPatternForm.param3_1 = this.dayDaily[0].label
      } else {
        this.subscriptionPatternForm.param1_1 = this.monthly[0].value
        this.subscriptionPatternForm.param1_2 = this.dayInMonth[0].value
        this.subscriptionPatternForm.param2_1 = this.monthly[0].value
        this.subscriptionPatternForm.param2_2 = this.weekNo[0].value
        this.subscriptionPatternForm.param2_3 = this.dayOfWeek[0].value
        this.subscriptionPatternForm.param3_1 = val.param1
      }
    },
    saveData() {
      localStorage.setItem(
        this.Constants.LOCAL_SUBSCRIPTION_AMAZON,
        JSON.stringify({
          addressId: this.addressId,
          cardSeq: this.cardSeq,
          subscriptionPatternForm: this.subscriptionPatternForm,
        })
      )
    },
    restoreData() {
      const data = localStorage.getItem(this.Constants.LOCAL_SUBSCRIPTION_AMAZON)

      if (data) {
        const parseData = Object.assign({ ...JSON.parse(data) })

        this.addressId = parseData.addressId
        this.cardSeq = parseData.cardSeq
        this.subscriptionPatternForm = Object.assign({ ...parseData.subscriptionPatternForm })

        localStorage.removeItem(this.Constants.LOCAL_SUBSCRIPTION_AMAZON)
      }
    },
    toListProduct() {
      this.$router.push({ name: 'EC_LINE016' })
    },
    async updateQuantity({ product_sku_id, quantity }) {
      this.loading = true
      try {
        await this.$store.commit('subscription/UPDATE_SKU_QUANTITY', { product_sku_id, quantity })
        await syncSubscriptionItems(this.deliveryFeeRequestFlag)
        await this.getDeliveryMethod(this.form.customer_address.postal_code, this.form.customer_address.pref.id)
        this.$nextTick(() => {
          this.resetDeliveryDateIfIsPauseOrCancel()
        })
      } finally {
        this.loading = false
      }
    },
    async removeItem({ product_sku_id, product_code }) {
      this.loading = true
      try {
        await this.$store.commit('subscription/REMOVE_SKU_ITEM', product_sku_id)
        const shopId = this.$store.getters['env/GET_KEY']('SHOP_ID')
        if (shopId === 1 && product_code === 'LT500s48') {
          const shouldRequestDeliveryFee = this.deliveryFee !== 0
          await syncSubscriptionItems(shouldRequestDeliveryFee)
        } else {
          await syncSubscriptionItems(this.deliveryFeeRequestFlag)
        }
        await this.getDeliveryMethod(this.form.customer_address.postal_code, this.form.customer_address.pref.id)
        this.$nextTick(() => {
          this.resetDeliveryDateIfIsPauseOrCancel()
        })
      } finally {
        this.loading = false
      }
    },
    showAddressDialog() {
      this.addressDialog = true
    },
    showCardDialog() {
      this.cardDialog = true
    },
    async updateDeliveryPatternForm(action_type) {
      // 出荷手配済みの受注が存在する場合は、次回配送日の更新は不可
      if (action_type === this.Constants.DELIVERY_PATTERN_ACTION_TYPE.NEXT_DELIVERY_DATE && this.hasShipArrangedOrder) {
        return
      }

      const form = {
        ...this.getBody(),
        action_type,
        subscription_id: this.id,
      }

      this.loading = true

      this.$refs.subscriptionPatternForm.clearValidate(['next_delivery_date', 'next_next_delivery_date'])

      SubscriptionService.getSubscriptionPatternForm(this.id, form)
        .then(({ data: val }) => {
          this.subscriptionPatternForm.subscription_division_id = val.subscription_division_id
          this.subscriptionPatternForm.next_delivery_date = val.next_delivery_date
          this.subscriptionPatternForm.next_next_delivery_date = val.next_next_delivery_date
          this.subscriptionPatternForm.autoCalcLastDeliveryDate = val.next_delivery_auto_calculation
          this.subscriptionPatternForm.autoCalcLastDeliveryDate2 = val.next_next_delivery_auto_calculation

          if (val.subscription_division_id === this.Constants.DELIVERY_PATTERN_CHANGE.MONTHLY_DATE_SPECIFICATION) {
            this.subscriptionPatternForm.param1_1 = val.param1
            this.subscriptionPatternForm.param1_2 = val.param2
            this.subscriptionPatternForm.param2_1 = this.monthly[0].value
            this.subscriptionPatternForm.param2_2 = this.weekNo[0].value
            this.subscriptionPatternForm.param2_3 = this.dayOfWeek[0].value
            this.subscriptionPatternForm.param3_1 = this.dayDaily[0].label
          } else if (val.subscription_division_id === this.Constants.DELIVERY_PATTERN_CHANGE.INTERVAL_DESIGNATION) {
            this.subscriptionPatternForm.param1_1 = this.monthly[0].value
            this.subscriptionPatternForm.param1_2 = this.dayInMonth[0].value
            this.subscriptionPatternForm.param2_1 = val.param1
            this.subscriptionPatternForm.param2_2 = val.param2
            this.subscriptionPatternForm.param2_3 = val.param3
            this.subscriptionPatternForm.param3_1 = this.dayDaily[0].label
          } else {
            this.subscriptionPatternForm.param1_1 = this.monthly[0].value
            this.subscriptionPatternForm.param1_2 = this.dayInMonth[0].value
            this.subscriptionPatternForm.param2_1 = this.monthly[0].value
            this.subscriptionPatternForm.param2_2 = this.weekNo[0].value
            this.subscriptionPatternForm.param2_3 = this.dayOfWeek[0].value
            this.subscriptionPatternForm.param3_1 = val.param1
          }
        })
        .then(
          () =>
            new Promise((resolve) =>
              this.$refs.subscriptionPatternForm.validateField(
                ['next_delivery_date', 'next_next_delivery_date'],
                (errMsg) => {
                  resolve(errMsg)
                }
              )
            )
        )
        .then(() => new Promise((resolve) => setTimeout(() => resolve(), 500)))
        .finally(() => (this.loading = false))
    },
    getBody() {
      return {
        subscription_division_id: this.subscriptionPatternForm.subscription_division_id,
        param1: this.subscriptionPatternForm[`param${this.subscriptionPatternForm.subscription_division_id}_1`],
        param2: this.subscriptionPatternForm[`param${this.subscriptionPatternForm.subscription_division_id}_2`],
        param3: this.subscriptionPatternForm[`param${this.subscriptionPatternForm.subscription_division_id}_3`],
        next_delivery_date: this.subscriptionPatternForm.next_delivery_date,
        next_next_delivery_date: this.subscriptionPatternForm.next_next_delivery_date,
        next_delivery_auto_calculation: this.subscriptionPatternForm.autoCalcLastDeliveryDate,
        next_next_delivery_auto_calculation: this.subscriptionPatternForm.autoCalcLastDeliveryDate2,
      }
    },
    //  submit
    async onSubmit(isPausing) {
      // not submit when disable form
      if (this.form && !this.form.subscription_order_item.length) {
        return
      }
      // step1 validate
      const valid = await this.validate()
      if (!valid.result) {
        this.handleError({ message: valid.message || this.$t('common.messages.hasInvalidData') })
        return
      }

      this.loading = true
      OrderService.validEmail({
        payment_method: this.paymentForm.payment_id,
        payment_total: this.totalAmount,
      })
        .then(() => {
          // step2 add data to state
          const body = {
            id: this.form.id,
            subscription_order_item: [...this.form.subscription_order_item],
            shipping: Object.assign({ ...this.customer_address }),
            delivery_fee: this.form.delivery_fee,
            subscription_pattern: Object.assign({
              ...this.subscriptionPatternForm,
              // next_delivery_date: this.next_delivery_date,
              // next_next_delivery_date: this.next_next_delivery_date,
              id: this.form.subscription_delivery_pattern.id,
              next_delivery_auto_calculation: this.subscriptionPatternForm.autoCalcLastDeliveryDate,
              next_next_delivery_auto_calculation: this.subscriptionPatternForm.autoCalcLastDeliveryDate2,
              time_id: undefined,
            }),
            payment:
              this.isFirstCreditCard || this.isCreditCardWithoutCard
                ? Object.assign({
                    ...this.paymentForm,
                  })
                : this.isCreditCard
                ? Object.assign({
                    payment_id: this.paymentForm.payment_id,
                    ...this.creditCardCurrent,
                  })
                : this.isAmazon
                ? Object.assign({
                    payment_id: this.paymentForm.payment_id,
                    // billing_agreement_id: this.amazon.billingAgreementId,
                  })
                : Object.assign({
                    payment_id: this.paymentForm.payment_id,
                  }),
            addresses: this.addresses,
            payment_methods: this.shopPaymentMethods,
            delivery_id: this.deliveryId ?? this.form.delivery_id,
            time_id: this.subscriptionPatternForm.time_id,
            cards: this.cards,
            payment_total: this.totalAmount,
            reopen_flag: isPausing,
            delivery_note_id: this.form.delivery_note_id,
            delivery_notes: this.form.delivery_notes,
            bundled_flag: this.form.bundled_flag,
            is_has_order_ship_arranged: this.hasShipArrangedOrder,
            delivery_division_id: this.deliveryDivisionId,
            cooling_off_flag: this.coolingOffFlag,
          }

          // step3 route
          this.$store.commit('subscription/SET_SUBSCRIPTION_CONFIRM', {
            ...body,
            subscription_pattern: {
              ...body.subscription_pattern,
            },
            delivery_text: this.deliveryTimezoneText,
            delivery_method_text: this.deliveryMethodText,
            bundled_flag_text: this.form.bundled_flag ? this.$t('common.action.canBe') : this.$t('common.action.none'),
            deliveryNotesText: this.isIncludedDeliveryNotes?.label || this.form.delivery_notes || '',
          })
          this.$store.commit(
            'subscription/SET_SUB_LIST_TYPE',
            this.isPausing ? this.Constants.EC_LINE009.TABS_TYPE.PAUSED : this.Constants.EC_LINE009.TABS_TYPE.NORMAL
          )
          this.$emit('confirm')
        })
        .catch((error) => this.handleError(error))
        .finally(() => (this.loading = false))
    },
    async validate() {
      if (this.totalAmount < 0) {
        return { result: false, message: this.$t('common.messages.invalidTotalAmount') }
      }
      if (this.disableForm || this.isPausing || this.isCanceling) {
        const valid = await new Promise((resolve) =>
          this.$refs.subscriptionPatternForm.validateField(
            ['next_delivery_date', 'next_next_delivery_date'],
            (errMsg) => {
              if (errMsg) resolve({ result: false })
              else resolve({ result: true })
            }
          )
        )

        if (!valid.result) {
          this.$refs.subscriptionPatternForm.$el.scrollIntoView({ behavior: 'smooth' })
          return valid
        }
      } else {
        const valid = await new Promise((resolve) =>
          this.$refs.subscriptionPatternForm.validate((valid) => {
            resolve(valid)
          })
        )

        if (!valid) {
          this.$refs.subscriptionPatternForm.$el.scrollIntoView({ behavior: 'smooth' })
          return { result: valid }
        }
      }

      if (!this.paymentForm.payment_id) {
        return { result: false }
      }
      if (this.isAmazon) {
        if (this.isCurrentAmazon) {
          return { result: true }
        }
        if (!this.totalAmount) {
          return { result: false, message: this.$t('ec-line015.content.amazonZeroAmountHint') }
        }
        if (!this.isLoginAmazon) {
          return { result: false, message: this.$t('common.messages.notYesLoginAmazon') }
        }
      } else if (this.isCreditCard) {
        if (!this.cards.length || this.isCreditCardWithoutCard) {
          const valid = await this.$refs.paymentForm.validate()
          return { result: valid }
        }

        return { result: this.cardSeq !== null }
      }
      return { result: true }
    },
    showCancelSubscriptionSection() {
      this.cancelSectionVisible = true
    },
    showCancelSubscriptionDialog() {
      this.cancelSubscriptionVisible = true
    },
    scrollPurchaseDetails(scroll) {
      if (scroll == 'purchaseDetails') {
        const topToElement1 = document.getElementsByClassName('scroll--purchaseDetails')[0]
        const offsetTop1 = topToElement1.offsetTop
        window.scroll({ behavior: 'smooth', top: offsetTop1 - 40 })
      }
    },
    scrollSubscription(scroll) {
      if (scroll == 'subscription') {
        const topToElement2 = document.getElementsByClassName('scroll-subscription')[0]
        const offsetTop2 = topToElement2.offsetTop
        window.scroll({ behavior: 'smooth', top: offsetTop2 - 40 })
      }
    },
    async onCancelSubscription(val) {
      const body = {
        cancellation_reason_id: val.cancelReason,
        cancellation_memo: val.cancelReasonDetail,
      }
      try {
        await SubscriptionService.cancelSubscription(this.id, body)
        this.$router.push({ name: 'EC_LINE014' })
        this.$alert({
          message: this.$t('ec-line015.content.cancelSection.cancelSuccessMessage'),
          type: 'success',
        })
      } catch (err) {
        this.handleError(err)
      }
    },
    toSubscriptionList() {
      this.$store.commit(
        'subscription/SET_SUB_LIST_TYPE',
        this.isPausing ? this.Constants.EC_LINE009.TABS_TYPE.PAUSED : this.Constants.EC_LINE009.TABS_TYPE.NORMAL
      )
      this.$router.push({
        name: 'EC_LINE014',
      })
    },
    onCancelDialog() {
      this.visibleConfirmDialog = false
    },
    handlePause() {
      this.pauseSubscriptionVisible = true
    },
    onAcceptPauseSubscription() {
      this.pauseSubscriptionVisible = false
      this.onPauseSubscription()
    },
    onPauseSubscription() {
      SubscriptionService.pauseSubscription(this.form.id)
        .then(() => {
          this.$store.commit('subscription/SET_SUB_LIST_TYPE', this.Constants.EC_LINE009.TABS_TYPE.PAUSED)
          this.$router.push({ name: 'EC_LINE014' })
          this.$alert({
            message: this.$t('ec-line015.content.pauseSection.pauseSuccesMessage'),
            type: 'success',
          })
        })
        .catch((error) => {
          this.handleError(error)
          if (error.response?.data.meta.app_status === this.Constants.EC_LINE009.ERROR_TYPE.CANCELED) {
            this.$store.commit('subscription/SET_SUB_LIST_TYPE', this.Constants.EC_LINE009.TABS_TYPE.NORMAL)
            this.$router.push({ name: 'EC_LINE014' })
          }
        })
    },
    onCancelDialogPause() {
      this.pauseSubscriptionVisible = false
    },
    fetchDataSubscription(initial = false) {
      return SubscriptionService.getSubscriptionDetail(this.id)
        .then(({ data }) => {
          this.subscriptionOrderItemInitial = data.subscription_order_item
          this.customerAddressIdInitial = data.customer_address.id
          this.subscriptionPatternForm.next_delivery_date = data.subscription_delivery_pattern.next_delivery_date
          this.subscriptionPatternForm.next_next_delivery_date =
            data.subscription_delivery_pattern.next_next_delivery_date
          this.dataSubscriptionPatternInitial = {
            id: data.subscription_delivery_pattern.id,
            next_delivery_auto_calculation: data.subscription_delivery_pattern.next_delivery_auto_calculation,
            next_delivery_date: data.subscription_delivery_pattern.next_delivery_date,
            next_next_delivery_auto_calculation: data.subscription_delivery_pattern.next_next_delivery_auto_calculation,
            next_next_delivery_date: data.subscription_delivery_pattern.next_next_delivery_date,
            subscription_division_id: data.subscription_delivery_pattern.subscription_division_id,
            param1: data.subscription_delivery_pattern.param1 || undefined,
            param2: data.subscription_delivery_pattern.param2 || undefined,
            param3: data.subscription_delivery_pattern.param3 || undefined,
            time_id: data.time_id,
          }
          this.disableForm = data.disable_next_delivery
          this.hasUnshipOrder = data.is_has_order_unship
          this.hasShipArrangedOrder = data.is_has_order_ship_arranged
          this.batchError.is_payment_error_in_btc1 = data.is_payment_error_in_btc1
          this.batchError.is_payment_error_in_btc6 = data.is_payment_error_in_btc6
          this.batchError.is_payment_error_in_btc7 = data.is_payment_error_in_btc7
          this.batchError.delivery_date = data.delivery_date_payment_error
          this.batchError.code = data.code
          this.deliveryDivisionId = data.delivery_division_id
          this.deliveryDivisionName = data.delivery_division_name
          this.coolingOffFlag = data.cooling_off_flag
          this.deliveryId = data.delivery_id

          if (initial && isEmpty(this.form)) {
            this.$store.commit('subscription/UPDATE_SUBSCRIPTION', {
              ...data,
              customer_address: {
                ...data.customer_address,
                pref: { id: data.customer_address.pref_id },
              },
            })
          }
        })
        .then(() => {
          DeliveryService.getDeliveryTime(this.form.delivery_id).then(({ data }) => {
            this.deliveryTimezones =
              data.map((item) => ({
                value: item.id,
                label: item.delivery_time,
                visible: item.visible,
              })) || []
          })
        })
        .catch((err) => this.handleError(err))
    },
    toChangePaymentPage(code) {
      this.$router.push({
        path: '/lpc/cpay',
        query: {
          code,
        },
      })
    },
    checkDisablePaymentMethod(item) {
      return item.rule_max !== null && item.rule_max < this.totalAmount
    },
    handleChangeTotalOrPaymentId() {
      if (!this.totalAmount && this.isLoginAmazon) {
        this.onAmazonLogout(AMAZON.ACCESS_TOKEN_015)
        this.paymentForm.payment_id = ''
        return
      }
      const paymentMethod = this.shopPaymentMethods.find((item) => item.id === this.paymentForm.payment_id)

      if (!isEmpty(paymentMethod) && paymentMethod.rule_max !== null && paymentMethod.rule_max < this.totalAmount) {
        paymentMethod.id === this.paymentForm.payment_id && (this.paymentForm.payment_id = '')

        if (this.isAmazon && this.isLoginAmazon) {
          this.onAmazonLogout(AMAZON.ACCESS_TOKEN_015)
          this.handleError({ message: this.hintAmazon })
        }
      }
    },
    resetDeliveryDateIfIsPauseOrCancel() {
      if (this.isPausing || this.isCanceling) {
        this.originSubscriptionPatternForm = Object.assign({}, this.subscriptionPatternForm)

        if (this.isOriginNDDLessThanMinDeliveryDate && !this.hasShipArrangedOrder) {
          this.subscriptionPatternForm.next_delivery_date = this.Utils.date.getDateString(this.deliveryMinDate)
          this.subscriptionPatternForm.autoCalcLastDeliveryDate = false
        }

        if (this.isOriginNNDDPast) {
          this.subscriptionPatternForm.autoCalcLastDeliveryDate2 = true
        }

        if ((this.isOriginNDDLessThanMinDeliveryDate || this.isOriginNNDDPast) && !this.hasShipArrangedOrder) {
          this.updateDeliveryPatternForm(this.Constants.DELIVERY_PATTERN_ACTION_TYPE.NEXT_DELIVERY_DATE)
        }
      }
    },
    changeDeliveryNotes() {
      this.form.delivery_notes = null
    },
    onChangePaymentMethods() {
      if (this.form.payment_service_id === this.Constants.PAYMENT_METHOD.CASH_ON_DELIVERY) {
        const paymentMethod = this.shopPaymentMethods.find(
          (item) => item.payment_service_id === this.Constants.PAYMENT_METHOD.NP
        )
        return (this.paymentForm.payment_id = paymentMethod.id)
      }
    },
    onChangePaymentMethod(paymentDialogType) {
      if (paymentDialogType === this.Constants.PAYMENT_DIALOG_TYPE.EDIT_CARD && !this.isNDDLessThanMinDeliveryDate)
        return
      this.changeNextDeliveryDate()
      this.changePaymentDialogTitle = this.$t(`ec-line015.changePaymentDialog.${paymentDialogType}.title`)
      this.changePaymentDialogContent = this.$t(`ec-line015.changePaymentDialog.${paymentDialogType}.content`)
      this.visibleChangePaymentDialog = true
    },
    changeNextDeliveryDate() {
      this.showPaymentWarningMsg = false
      if (this.isNDDLessThanMinDeliveryDate && !this.hasShipArrangedOrder) {
        this.subscriptionPatternForm.next_delivery_date = this.Utils.date.getDateString(this.deliveryMinDate)
        this.updateDeliveryPatternForm(this.Constants.DELIVERY_PATTERN_ACTION_TYPE.NEXT_DELIVERY_DATE)
        this.showPaymentWarningMsg = true
      }
    },

    updateAddress() {
      const shippingInfo = this.addresses?.find((item) => item.id === this.addressId)

      if (!shippingInfo) return

      this.form.customer_address = {
        ...this.form.customer_address,
        id: shippingInfo.id,
        name01: shippingInfo.name01 || '',
        name02: shippingInfo.name02 || '',
        kana02: shippingInfo.kana01 || '',
        kana01: shippingInfo.kana02 || '',
        postal_code: shippingInfo.postal_code || '',
        pref_id: shippingInfo.pref?.id || '',
        addr01: shippingInfo.addr01 || '',
        addr02: shippingInfo.addr02 || '',
        addr03: shippingInfo.addr03 || '',
        phone_number: this.Utils.helper.getOnlyNumber(shippingInfo.phone_number),
      }
    },

    toCpayPage() {
      window.location.href = `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/lpc/cpay?code=${
        this.batchError.code
      }`
    },
    verifyDeliveryPatternByLumpSumPayment() {
      if (this.hasLumpSumPayment) {
        this.subscriptionPatternForm.param1_1 = this.monthly[0].value
        this.subscriptionPatternForm.param2_1 = this.monthly[0].value

        if (
          this.subscriptionPatternForm.subscription_division_id ===
          this.Constants.DELIVERY_PATTERN_CHANGE.SPECIFY_DELIVERY_DATE_INTERVAL
        ) {
          this.subscriptionPatternForm.subscription_division_id =
            this.Constants.DELIVERY_PATTERN_CHANGE.MONTHLY_DATE_SPECIFICATION
        }
      }
    },
    getDisplayedLabel(val) {
      if (!this.deliveryTimezones) {
        return this.$t('common.placeholder.unavailableTimeZone')
      }
      const matchedTime = this.deliveryTimezones.find((item) => item.value === val)
      if (!matchedTime) {
        return this.$t('common.placeholder.unspecified')
      }
      return matchedTime.label
    },
    checkBundledFlagByProduct() {
      if (this.hasNomuSilicaLightProduct) {
        this.form.bundled_flag = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/ec-line015/subscription-info-form.scss';
</style>
